export const ACCOUNTS = `
gCalendarAccounts {
    id
    userId
    oauthTokenId
    userFullName
    userEmail
    subscriptionIds
    googleAccountEmail
}`

export const TAGS = `
defaultTags {
    id
    tagId
}`

export const TAG_KEYWORDS = `
tagKeywords {
  id
  tagId
  keyword
}
`

export const AVAILABLE_CALENDARS = `
availableCalendars {
  id
  title
  gCalendarAccountId
  googleAccountEmail
  isSubscribed
}
`

export const ATTENDEE_USERS = `
attendeeUsers {
  id
  userId
  userFullName
  userPrimaryEmail
  attendeeEmail
}
`

export const SUBSCRIPTIONS = `
  gCalendarSubscriptions {
    id
    gCalendarId
    gCalendarName
    googleAccountEmail
    userId
}
`

export const MEMBERS = `
  members {
    id
    userId
    name
    email
}
`
const completeConfig = `{
  id
  teamId
  defaultDescription
  createRecordsForMembers
  createAllDayRecords
  ${TAGS}
  ${TAG_KEYWORDS}
  ${ATTENDEE_USERS}
  ${ACCOUNTS}
  ${SUBSCRIPTIONS}
  ${AVAILABLE_CALENDARS}
  ${MEMBERS}
}`

export const GET_GOOGLE_CALENDAR_CONFIGS = `{
  gCalendarConfig ${completeConfig}
}`

export const GET_GOOGLE_CALENDAR_CONFIG = id => `{
  gCalendarConfig(gCalendarConfigId: "${id}") ${completeConfig}}`

export const GET_GOOGLE_CALENDAR_CONFIG_TAGS = id => `{
        gCalendarConfig(gCalendarConfigId: "${id}") {${TAGS}}}`

export const buildCalendarQuery = (id, params) => {
    const paramsString = params.reduce((acc, param) => {
        return acc + ` ${param}`
    }, "")

    return ` {
    gCalendarConfig(gCalendarConfigId: "${id}") {${paramsString}}}`
}



// WEBPACK FOOTER //
// ./src/graphql_queries/goolge_calendar_config_queries.js